module.exports = __webpack_public_path__ + "static/img/wechatpay-qrcode.0819523b.png";